import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { MessageField } from '@/@vxapp/@Enums/PHP/ServicesV2/Messages/DataProviders/MessageField'
import { MessageDataField } from '@/@vxapp/@Enums/PHP/ServicesV2/Messages/DataProviders/MessageDataField'
import { DateField } from '@/@vxapp/@Enums/PHP/core/Database/Enums/DateField'

export const MessagesTableHeaders = [
  {
    title: '#ID',
    align: 'start',
    key: 'id',
    placeholder: '00000',
  },
  {
    title: 'Status',
    align: 'start',
    key: MessageField.STATUS,
    sortable: false,
    placeholder: 'queue',
  },
  {
    title: 'Subject',
    align: 'start',
    key: MessageField.MESSAGE_DATA + '.' + MessageDataField.SUBJECT,
    sortable: false,
    placeholder: 'Message Subject',
  },
  {
    title: 'Sent On',
    align: 'start',
    key: MessageField.SENT_ON,
    sortable: true,
    placeholder: 'Oct 31, 2025 00:02:14',
  },
  {
    title: 'Created At',
    align: 'start',
    key: DateField.CREATED_AT,
    sortable: true,
    placeholder: 'Oct 31, 2025 00:02:14',
  },
  {
    title: 'Type',
    align: 'start',
    key: MessageField.TYPE,
    sortable: false,
    placeholder: 'Message Type',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
